
import utils from '@/utils';
import api from '@/api/register';
import { IElForm } from '@/types/element';
import { defineComponent } from 'vue';
import { PAGE_TYPE_LOGIN } from '../pageType';

interface IForm {
  userName: string;
  mobile: string;
  code: string;
  password: string;
  confirmPassword: string;
}

interface IState {
  redirect: string;
  isAgreement: boolean;
  errorMessage: string;
  countdown: number;
  form: IForm;
  interval?: number;
  validateMobile: (rule: { message: string }, value: string, callback: (error?: Error) => void) => void;
}

export default defineComponent({
  data() {
    return {
      redirect: this.$route.query.redirect,
      isAgreement: false,
      errorMessage: '',
      countdown: 0,
      form: {
        userName: '',
        mobile: '',
        code: '',
        password: '',
        confirmPassword: '',
      },
      interval: 0,
      validateMobile: utils.validateMobile,
    } as IState;
  },
  methods: {
    apiSendSms() {
      api.sendSms(
        {
          mobile: this.form.mobile,
        },
        (res) => {
          if (!res.value) return;
          utils.notifySuccess('验证码发送成功，10分钟内有效');
          this.countdown = 60;
          this.interval = window.setInterval(() => {
            this.countdown -= 1;
            if (this.countdown <= 0) {
              clearInterval(this.interval);
            }
          }, 1000);
        },
      );
    },

    apiSubmit() {
      api.submit(
        {
          userName: this.form.userName,
          password: this.form.password,
          mobile: this.form.mobile,
          code: this.form.code,
        },
        (res) => {
          utils.loading(false);
          if (res.value) {
            utils.alertSuccess(
              {
                title: '恭喜，账号注册成功',
                button: '进入登录页',
              },
              () => {
                this.btnLoginClick();
              },
            );
          }
        },
        (errorMessage: string) => {
          this.errorMessage = errorMessage;
          utils.loading(false);
        },
      );
    },

    isMobileValid(value: string) {
      return /^1[3-9][0-9]\d{8}$/.test(value);
    },

    btnSendSmsClick() {
      if (this.countdown > 0) return;
      if (!this.form.mobile) {
        this.errorMessage = '手机号码不能为空';
        return;
      }
      if (!this.isMobileValid(this.form.mobile)) {
        this.errorMessage = '请输入有效的手机号码';
        return;
      }

      this.apiSendSms();
    },

    btnRegisterClick() {
      this.errorMessage = '';
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          this.apiSubmit();
        }
      });
    },

    btnLoginClick() {
      this.$emit('redirect', PAGE_TYPE_LOGIN);
    },

    validatePass(rule: string, value: string, callback: (error?: Error) => void) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    },
  },
  mounted() {
    utils.loading(false);
  },
});
